import {k} from './kaplay.js'
import './assets.js'
import './scenes/menu.js'
import './scenes/game.js'
import './scenes/result.js'

k.go("menu")
